import { contentBoxShadow, overlayBoxShadow, } from "@mittwald/flow-styles/dist/mixins/boxShadow";
import { css } from "styled-components";
import { PropsType } from "../lib/Props";
import { breakpointProp } from "./breakpointProp";
export const shadowMixinPropsType = new PropsType({
    _shadow: true,
});
export const shadowMixin = css `
  ${breakpointProp("_shadow", (v) => {
    switch (v) {
        case "overlayBox":
            return overlayBoxShadow;
        case "contentBox":
            return contentBoxShadow;
        default:
            return "";
    }
})}
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2hhZG93LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL21peGlucy9zaGFkb3cudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUNMLGdCQUFnQixFQUNoQixnQkFBZ0IsR0FDakIsTUFBTSw2Q0FBNkMsQ0FBQztBQUNyRCxPQUFPLEVBQUUsR0FBRyxFQUFFLE1BQU0sbUJBQW1CLENBQUM7QUFDeEMsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLGNBQWMsQ0FBQztBQUN6QyxPQUFPLEVBQUUsY0FBYyxFQUFzQixNQUFNLGtCQUFrQixDQUFDO0FBU3RFLE1BQU0sQ0FBQyxNQUFNLG9CQUFvQixHQUFHLElBQUksU0FBUyxDQUFtQjtJQUNsRSxPQUFPLEVBQUUsSUFBSTtDQUNkLENBQUMsQ0FBQztBQUVILE1BQU0sQ0FBQyxNQUFNLFdBQVcsR0FBRyxHQUFHLENBQWtCO0lBQzVDLGNBQWMsQ0FBQyxTQUFTLEVBQUUsQ0FBQyxDQUFDLEVBQUUsRUFBRTtJQUNoQyxRQUFRLENBQUMsRUFBRSxDQUFDO1FBQ1YsS0FBSyxZQUFZO1lBQ2YsT0FBTyxnQkFBZ0IsQ0FBQztRQUMxQixLQUFLLFlBQVk7WUFDZixPQUFPLGdCQUFnQixDQUFDO1FBQzFCO1lBQ0UsT0FBTyxFQUFFLENBQUM7SUFDZCxDQUFDO0FBQ0gsQ0FBQyxDQUFDO0NBQ0gsQ0FBQyJ9